import {Component} from '@angular/core';
import { Router } from '@angular/router';
import {GoogleAnalytics} from '@ionic-native/google-analytics/ngx';
import { ModalController } from '@ionic/angular';
import { AutoCompletePlacePage } from '../modals/auto-complete-place/auto-complete-place.page';
import { GeoCodeService } from '../services/geo-code.service';

declare var amplitude;

@Component({
    selector: 'app-home',
    templateUrl: 'home.page.html',
    styleUrls: ['home.page.scss'],
})
export class HomePage {

    slideOpts = {
        initialSlide: 1,
        speed: 400,
    };

    date = new Date();
    copyright = this.date.getFullYear();
    selectedPlace: string;

    constructor(private ga: GoogleAnalytics, private modalCtrl: ModalController, 
        public geoCodeService: GeoCodeService, private router: Router) {
    }

    ionicViewDidEnter() {
        this.ga.startTrackerWithId('G-HTP42S7Y3P')
            .then(() => {
                console.log('Google Analytics tracker is ready');
                this.ga.trackView('Home Page');
            })
            .catch(e => console.log('Error starting Google Analytics', e));
    }

    ionViewDidEnter() {
        amplitude.logEvent('mobile::viewed_home_page');
    }

    async showAddressModal() {
        const modal = await this.modalCtrl.create({
            component: AutoCompletePlacePage
        });
        modal.onDidDismiss()
            .then((data) => {
                const selectedPlaceData = data;
                if (selectedPlaceData) {
                    this.selectedPlace = selectedPlaceData.data;
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({
                        address: this.selectedPlace
                    }, (results, status) => {
                        if (status === google.maps.GeocoderStatus.OK) {
                            this.geoCodeService.codeAddress(this.selectedPlace).subscribe( geodata => {
                              const geometry = geodata[0].geometry;
                              const resLat = results[0].geometry.location.lat();
                              const resLng = results[0].geometry.location.lng();
                              let newPlaceBounds;
                             let defaultBounds = {
                                    sw_lat: 48.732117759871834,
                                    sw_lng: -123.3491237265625,
                                    ne_lat: 49.6057435563008,
                                    ne_lng: -122.61029316015625,
                                    resLat: 49.2488091,
                                    resLng: -122.9805104    
                                };

                                const boundsSource = geometry.bounds || geometry.viewport;

                                if (boundsSource) {
                                    const boundaries = {
                                        NE: this.geoCodeService.googleLatLngToJson(boundsSource.getNorthEast()),
                                        SW: this.geoCodeService.googleLatLngToJson(boundsSource.getSouthWest())
                                    };

                                    newPlaceBounds = {
                                        sw_lat: boundaries.SW.latitude,
                                        sw_lng: boundaries.SW.longitude,
                                        ne_lat: boundaries.NE.latitude,
                                        ne_lng: boundaries.NE.longitude,
                                        resLat: resLat,
                                        resLng: resLng
                                    };
                                } else {
                                    newPlaceBounds = defaultBounds; 
                                }

                                //Hardcoded it for  -#PBL-1029 - To rework
                                if(results[0]['formatted_address'] == 'Vancouver, BC, Canada'){
                                    newPlaceBounds = defaultBounds; 
                                }
                              this.router.navigate(['/search/promotions'], { queryParams: newPlaceBounds } )
                              this.selectedPlace = '';
                            
                            });
                        }
                    });
                }
            });
        return await modal.present();
    }

}
